export default __webpack_public_path__ + "static/media/resume.76654eea.pdf";